<template>
  <div id="app">
    <v-app id="inspire">
      <v-container>
        <v-stepper
          v-model="pge"
          elevation="24"
          max-width="90%"
          vertical
          class="mt-6"
        >
          <!-- PAGE 1 -->
          <v-stepper-step :complete="pge > 1" step="1">
            Welcome
            <!-- <small>Summarize if needed</small> -->
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card color="grey lighten-3" class="mb-12">
              <v-container class="pa-4 pr-8">
                <!-- <vue-markdown :source="greeter_markdown" /> -->
                <div v-html="greeter"></div>
              </v-container>
            </v-card>
            <v-btn
              color="primary"
              @click="pge = 2"
              :disabled="
                user_data.pif_data.provider == '-' ||
                user_data.pif_data.provider == '[unassigned]' ||
                !user_data.pif_data.provider
              "
            >
              Continue
            </v-btn>
          </v-stepper-content>

          <!-- PAGE 2 -->
          <v-stepper-step :complete="pge > 2" step="2">
            Confirm signup details
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card color="grey lighten-3" class="mb-12">
              <!-- Models -->

              <v-card-text>
                <v-row class="mb-2"><v-divider></v-divider></v-row>

                <v-row justify="center"
                  ><h2><b>Your Model</b></h2>
                  </v-row>

                <v-row class="mb-4 mt-4" justify="center">
                  <v-btn-toggle
                    v-model="user_data.pif_data.model"
                    tile
                    color="red accent-3"
                  >
                    <v-btn
                      v-for="item in models"
                      v-bind:key="item.id"
                      :value="item"
                      x-large
                    >
                      <v-col>
                        {{ item }}
                      </v-col>
                    </v-btn>
                  </v-btn-toggle>
                </v-row>

                <v-container v-if="user_data.pif_data.model != null">
                  <v-row class="mb-2"><v-divider></v-divider></v-row>
                  <v-row justify="center">
                    <h3>Your Hotend mount</h3>
                  </v-row>

                  <v-row class="mb-4 mt-4" justify="center">
                    <v-btn-toggle
                      v-model="user_data.pif_data.hotend"
                      tile
                      color="red accent-3"
                    >
                      <v-btn
                        v-for="item in hotends"
                        v-bind:key="item.id"
                        :value="item"
                      >
                        {{ item }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>
                </v-container>


                <!-- Electronics -->
                <v-container v-if="user_data.pif_data.hotend != null">
                  <v-row class="mb-2"><v-divider></v-divider></v-row>
                  <v-row justify="center">
                    <h3>Your electronic mount</h3>
                  </v-row>
                  <v-row class="mb-4 mt-4" justify="center">
                    <v-btn-toggle
                      v-model="user_data.pif_data.electronic"
                      tile
                      color="red accent-3"
                    >
                      <v-btn
                        v-for="item in electronics"
                        v-bind:key="item.id"
                        :value="item"
                      >
                        {{ item }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>
                </v-container>

                <!-- Extras -->
                <v-container v-if="user_data.pif_data.electronic != null && extras.length >0 ">
                  <v-row class="mb-2"><v-divider></v-divider></v-row>
                  <v-row justify="center">
                    <h3>Choose Extras</h3>
                  </v-row>
                  <v-row class="mb-4 mt-4" justify="center">
                    <v-btn-toggle
                      v-model="user_data.pif_data.extra"
                      tile
                      color="red accent-3"
                    >
                      <v-btn
                        v-for="item in extras"
                        v-bind:key="item.id"
                        :value="item"
                      >
                        {{ item }}
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>
                </v-container>

                <!-- Extrasprovider -->
                <v-container v-if="user_data.pif_data.electronic != null && provider_extras.length >0 ">
                  <v-row class="mb-2"><v-divider></v-divider></v-row>
                  <v-row justify="center">
                    <h3>Hotend mount upgrade</h3>
                  </v-row>
                  <v-row class="mb-4 mt-4" justify="center">
                    <v-btn-toggle
                      v-model="user_data.pif_data.provider_extras"
                      tile
                      color="red accent-3"
                    >

                      <v-btn
                        v-for="item in provider_extras"
                        v-bind:key="item.id"
                        :value="item"
                      >
                        {{ item }}
                      </v-btn>

                    </v-btn-toggle>
                  </v-row>
                </v-container>
                

                <v-container v-if="user_data.pif_data.electronic != null">
                  <v-row class="mb-2"><v-divider></v-divider></v-row>
                  <v-row class="ma-4" justify="center">
                    <h1>
                      <b>
                        &gt; &gt; &nbsp; &nbsp;
                        {{ user_data.pif_data.accent }} &nbsp; &nbsp; &lt;&lt;
                      </b>
                    </h1>
                  </v-row>
                  <v-row>
                    <v-carousel class="mx-16" height="500" v-model="accent_index">
                      <v-carousel-item
                        class="mx-16"
                        v-for="(item, key) in colors"
                        :key="key"
                        :src="item"
                      >
                      </v-carousel-item>
                    </v-carousel>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
            <v-btn :disabled="!user_data.pif_data.accent" color="primary" @click="pge = 3"> Continue </v-btn>
            <v-btn right text @click="pge = 1"> back </v-btn>
          </v-stepper-content>

          <!-- PAGE 3 -->
          <v-stepper-step :complete="pge > 3" step="3"
            >Enter your Adress</v-stepper-step
          >
          <v-stepper-content step="3">
            <v-card color="grey lighten-3" class="mb-12">
              <v-card-title class="mx-1"
                >Enter your address here and click on the best match from the proposed list.</v-card-title
              >
              <v-form
                ref="form"
                class="mx-4"
                v-model="address_valid"
                lazy-validation
              >
                <v-row>
                  <v-col>
                    <vuetify-google-autocomplete
                      label="Example: 65619, 742 Evergreen Terrace, Springfield"
                      filled
                      outlined
                      id="map"
                      v-on:placechanged="getAddressData"
                    >
                    </vuetify-google-autocomplete>
                  </v-col>
                </v-row>
                <v-divider class="mt-2 mb-6 mx-1"></v-divider>
                <v-container v-if="!adrress_disabled">
                  <v-row>
                    <!-- Alternativ readonly? mal probieren? -->
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.name1"
                        label="First Name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.name2"
                        label="Last Name"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        v-model="user_data.shipping_data.company"
                        label="Company"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.address1"
                        label="Adress Line 1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="user_data.shipping_data.address2"
                        label="Address Line 2"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.country"
                        label="Country"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.zip"
                        label="Zipcode"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.city"
                        label="City"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.state"
                        label="State"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.email"
                        label="Email"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <v-text-field
                        required
                        :rules="[(v) => !!v || 'Item is required']"
                        v-model="user_data.shipping_data.phone"
                        label="Phone"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
            <v-btn color="primary" @click="validate_form">
              Continue
            </v-btn>
            <v-btn right text @click="pge = 2"> back </v-btn>
          </v-stepper-content>

          <!-- PAGE 4 -->
          <v-stepper-step step="4"> Confirmation and payment </v-stepper-step>
          <v-stepper-content step="4">
            <v-card color="grey lighten-3" class="mb-12">
              <v-row v-if="!payment_done">
                <v-col class="my-8 mx-10">
                  <h3>Summary</h3>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="item in paypal_items" :key="item.name">
                          <td>{{ item.name }}</td>
                          <td class="text-right">
                            {{ item.price | currency }}
                          </td>
                        </tr>
                        <tr></tr>
                        <tr>
                          <td><b>Total</b></td>
                          <td class="text-right" style="width: 50px">
                            <b> {{ price_total(paypal_items) | currency }} </b>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>

              <v-container v-if="price_total(paypal_items) > 1">
                <v-row v-if="!payment_done">
                  <v-col></v-col>
                  <v-col
                    class="mx-4"
                  >
                    <!-- https://developer.paypal.com/developer/applications/create -->
                    <PayPal
                      :amount="String(price_total(paypal_items))"
                      currency="EUR"
                      :client="paypal"
                      env="production"
                      v-on:payment-completed="pp_completed"
                      :button-style="pp_btn_style"
                      :items="paypal_items"
                    >
                      ></PayPal
                    >
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-container>
              <v-container v-else>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr class="ma-16">
                        <td class="text-h6 text-center"><b>If you can see this, your total cant be calculated. This is usually the case if shippingcosts cant be calculated. Please receck your address. If you think its correct, contact your provider.</b></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

              </v-container>
              <v-row v-if="payment_done">
                <v-col class="ma-6">
                  <v-alert type="success">
                    Payment confirmed. Your data has been transmitted.
                  </v-alert>

                  <v-card class="mx-auto my-12" max-width="100%">
                    <v-card-title>Whats next ?</v-card-title>
                    <v-card-text>
                      Your kit gets boxed and you get a tracking number. As most
                      providers work in batches, this may take up to a week.
                      Please contact your Provider if you have any questions.
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
            <!-- <v-btn color="success" to="/"> CLOSE </v-btn> -->
            <v-btn color="success" @click="window.close()"> CLOSE </v-btn>
            <v-btn v-if="!payment_done" right text @click="pge = 3">
              back
            </v-btn>
          </v-stepper-content>
        </v-stepper>
        <v-row justify="center">
          <v-alert
            :value="
              ($store.state.auth && !user_data.pif_data.provider) ||
              user_data.pif_data.provider == '-' ||
              user_data.pif_data.provider == '[unassigned]'
            "
            color="red"
            prominent
            max-width="70%"
            dark
            border="top"
            icon="mdi-firework"
            transition="scale-transition"
          >
            Your PIF Slot is not assigned to a provider.
          </v-alert>
        </v-row>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import PayPal from "vue-paypal-checkout";
// import VueMarkdown from "vue-markdown-render";

import kit_config from "../configs/pifkits.json";
import user_data from "../configs/user_data.json";
import provider_data from "../configs/provider_data.json";

export default {
  components: {
    // VueMarkdown,
    PayPal,
  },
  computed: {},

  filters: {
    currency: function (value) {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
  },

  mounted() {
    this.fetchcolors(require.context("../../public/colors/", true, /(\.jpg|\.JPG)/));
  },

  watch: {
    "$store.state.auth": function () {
      if (
        this.$store.state.user_data.Assigned &&
        this.$store.state.user_data.Assigned != "-" &&
        this.$store.state.user_data.Assigned != "[unassigned]"
      ) {
        this.pge = 1;
      }
    },
    pge: function () {
      var vuethis = this;

      if (this.pge == 4) {
        var prov = user_data.pif_data.provider;
        var mod = user_data.pif_data.model;

        this.paypal_items = [];
        //var query = provider_data[prov].shipping;
        let query = Object.assign({}, provider_data[prov].shipping);
        query.to.zip = user_data.shipping_data.zip;
        query.to.country = this.$store.state.user_data.Country;
        query.packages = [ query.packages[mod] ];
        this.user_data['shipping_data']['package'] = Object.assign( {}, provider_data[prov].shipping.packages[mod] )

        axios({
          url: "https://idn1dgbtvl.execute-api.eu-central-1.amazonaws.com/default/shipping_handler?q=services",
          method: "post",
          data: JSON.stringify(query),
        })
          .then(function (response) {
            user_data.shipping_data.offer = response.data;

            vuethis.paypal_items.push({
              name:
                "PIF KIT " +
                mod +
                " (" +
                user_data.pif_data.hotend +
                " / " +
                user_data.pif_data.electronic +
                " / " +
                user_data.pif_data.accent +
                " ) " +
                user_data.pif_data.nick,
              description: "accent: " + user_data.pif_data.accent,
              quantity: "1",
              price: String( vuethis.financial_round(kit_config[mod].baseprice) ),
              currency: "EUR",
            });

            if (user_data.pif_data.extra) {
              vuethis.paypal_items.push({
                name: user_data.pif_data.extra,
                description: user_data.pif_data.extra,
                quantity: "1",
                price: String( vuethis.financial_round( kit_config[mod]["extras"][user_data.pif_data.extra] ) ),
                currency: "EUR",
              });
            }
            if (user_data.pif_data.provider_extras) {
              vuethis.paypal_items.push({
                name: user_data.pif_data.provider_extras,
                description: user_data.pif_data.provider_extras,
                quantity: "1",
                price: String( vuethis.financial_round( kit_config[mod]["provider_extras"][user_data.pif_data.provider_extras] ) ),
                currency: "EUR",
              });
            }

            vuethis.paypal_items.push({
              name:
                "Shipping to " +
                user_data.shipping_data.country + " " +
                user_data.shipping_data.zip + " " +
                user_data.shipping_data.offer.carrier + " " +
                user_data.shipping_data.offer.product,
              description: user_data.shipping_data.offer.product,
              quantity: "1",
              price: String( vuethis.financial_round(user_data.shipping_data.offer.price) ),
              currency: "EUR",
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    "$store.state.user_data": function () {
      var model_in = this.$store.state.user_data.Model
      //const containsKey = (obj, key ) => Object.keys(obj).includes(key);
      if ( ! kit_config[model_in] ) {
        var model_out = kit_config['translation'][model_in]
      } else {
        model_out = model_in
      }
      console.log( "model" )
      console.log( model_out )
      if ( model_out == "V0.1" ) {
        model_out = "V0.2"  
      }
      // pif related
      this.user_data.pif_data.model = model_out
      this.user_data.pif_data.provider = this.$store.state.user_data.Assigned;
      this.user_data.pif_data.nick = this.$store.state.user_data.Discord;
      // address related
      this.user_data.shipping_data.zip = this.$store.state.user_data.Zip;
      this.user_data.shipping_data.country =
        this.$store.state.user_data.Country;
      this.user_data.shipping_data.email = this.$store.state.user_data.Email;
    },
    "user_data.pif_data.model": function () {
      var mod = this.user_data.pif_data.model;
      this.hotends = kit_config[mod].hotends;
      this.electronics = kit_config[mod].electronics;
      this.extras = Object.keys( kit_config[mod].extras );
      this.provider_extras = Object.keys( kit_config[mod].provider_extras );
      //  custom greeter per model
      this.greeter = provider_data[user_data.pif_data.provider].greeters[mod]
    },
    user_data: {
      deep: true,
      handler () {
        this.$refs.form.validate();
      },
    },
    accent_index: {
      handler() {
        this.user_data.pif_data.accent = Object.keys(this.colors)[
          this.accent_index
        ];
      },
    },
  },

  methods: {
    fetchcolors: function (r) {
      r.keys().forEach(
        (key) => (this.colors[key.slice(2, -4)] = "colors/" + key.slice(2, 99))
      );
    },
    get_locale() {
      console.log(window.mylocale);
      return window.mylocale;
    },
    validate_form() {
      this.$refs.form.validate();
      if ( this.address_valid && !this.adrress_disabled ) {
        this.pge += 1
      }
    },
    submit_data: function () {
      this.user_data.shipping_data.country = this.$store.state.user_data.Country;
      var vuethis = this
      axios({
        url: "https://idn1dgbtvl.execute-api.eu-central-1.amazonaws.com/default/shipping_handler?q=order",
        method: "post",
        data: JSON.stringify(vuethis.user_data),
      })
        .then(function () {
          console.log("Submitted folowing object:")
          console.log( JSON.stringify(vuethis.user_data) )
        })
        .catch(function (error) {
          console.log(error);
        });
      // store CSV too
      axios({
        url: "https://51z6wp9ik7.execute-api.eu-central-1.amazonaws.com/default/pif_pickup_callback",
        method: "post",
        data: vuethis.user_data,
      })
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAddressData: function (addressData) {
      console.log("google gave: ", addressData)
      this.adrress_disabled = false;
      this.user_data.shipping_data.address1 = addressData.name;
      this.user_data.shipping_data.zip = addressData.postal_code;
      this.user_data.shipping_data.city = addressData.locality;
      this.user_data.shipping_data.state =
        addressData.administrative_area_level_1;
      //this.user_data.shipping_data.state = this.user_data.shipping_data.country;
      this.address_valid = false;
    },
    price_total: function (item) {
      
      var total = 0.00;
      var vuethis = this
      item.forEach((element) => {
        total += vuethis.financial_round(parseFloat(element.price))
        //console.log("total: ", this.financial_round(total))
      });
      return this.financial_round(total);

    },
    pp_completed: function () {
      this.payment_done = true;
      this.submit_data();
    },
    financial_round(x) {
      return parseFloat(Number.parseFloat(x).toFixed(2));
    }
  },

  data() {
    return {
      user_data,
      paypal_items: [],
      provider_data,
      paypal: {
        sandbox:
          "ATQNdyDqo0qxbY9oCZtNpVbJHsKBLV8tNEtqCsdZVjLVvKqMtiniF0oGT0uVMTDa_jjZcmZtKCUOPM5f",
        production:
          "AWY_HpG2lHgVQB35xvUG4E6Yd8Tq-TuobV-F_RG-X-g9wVg0ceNaFf4jDWAPj2YYI9O__rjuQLl3S6Rb",
      },
      pp_btn_style: {
        label: "checkout",
        size: "responsive",
        shape: "pill",
        color: "gold",
      },
      pge: 0,
      adrress_disabled: true,
      address_valid: false,
      payment_done: false,
      //  TODO import from config file
      colors: {},
      accent_index: 0,
      models: Object.keys(kit_config).slice(0, -1),
      hotends: [],
      electronics: [],
      extras: [],
      greeter: "<h3> YOUR PROVIDER HAS NO GREETER FOR YOUR MODEL </h3>"
    };
  },
};
</script>
